// extracted by mini-css-extract-plugin
export default {"background":"build_background__8rfBo","control":"build_control__EaBD0","leftSide":"build_leftSide__LHxnb","rightSide":"build_rightSide__hR9Ls"};